import { User } from "lucide-react";
import { Button, Navbar } from "flowbite-react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate, Link, useLocation } from "react-router-dom";

// Store
import { useStore } from "../../store";

import { SmallText } from "../../lib/ui/components/typography/Typography";
import Dropdown from "../../lib/ui/components/dropdown/Dropdown";

function Header() {
  const uid = useStore((state) => state.uid);
  const setLogout = useStore((state) => state.setLogout);
  const auth = getAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/login") return null;

  const isOnHomePage = location.pathname === "/";
  const isOnAuthPage = ["/login", "/register", "/reset-password"].includes(location.pathname);
  const isOnInterviewPage = location.pathname.startsWith("/interview/") || location.pathname.startsWith("/i/");
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setLogout();
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <nav className="h-16">
      <Navbar fluid rounded className="bg-white text-black">
        <div className="flex items-center space-x-8">
          <Navbar.Brand>
            <img
              src="/june logo png.png"
              className="ml-12 mr-2 h-4 sm:h-4"
              alt="4amd Hiring Logo"
            />
          </Navbar.Brand>
          {!isOnAuthPage && !isOnInterviewPage && (
            <>
              <Link 
                to="/jobs" 
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: 'none' }}
              >
                <SmallText weight="semibold">
                  Roles
                </SmallText>
              </Link>
              
              <Link 
                to="/applicant-search" 
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: 'none' }}
              >
                <SmallText weight="semibold">
                  Applicant Search
                </SmallText>
              </Link>
              
              <Link 
                to="/settings/profile" 
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: 'none' }}
              >
                <SmallText weight="semibold">
                  Settings
                </SmallText>
              </Link>
            </>
          )}
        </div>
        <div className="flex md:order-2 text-dark items-center space-x-4">
          {isOnHomePage || isOnAuthPage || isOnInterviewPage ? 
          (
            <div className="border-2 border-transparent bg-transparent"> {/* Invisible placeholder to maintain layout */}
              <div className="w-20 h-10"></div> 
            </div>
          ) : (
            uid ? (
              <Dropdown
                placement="bottom-end"
                trigger={
                  <button 
                    className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                    aria-label="User menu"
                    data-cy="user-menu-button"
                  >
                    <User size={20} className="text-gray-700" />
                  </button>
                }
                items={[
                  {
                    label: 'Sign Out',
                    onClick: handleSignOut,
                    variant: 'danger'
                  }
                ]}
              />
          ) : (
            <Link to="/login">
              <Button className="border-2 border-blue-500 text-blue-500 bg-transparent hover:bg-blue-500 hover:text-white text-label transition-all duration-300 ease-in-out">
                Log in
              </Button>
            </Link>
          ))}
        </div>
      </Navbar>
    </nav>
  );
}

export default Header;
